import { render, staticRenderFns } from "./guide-modal.vue?vue&type=template&id=dab04ff2&scoped=true&lang=pug&"
import script from "./guide-modal.vue?vue&type=script&lang=js&"
export * from "./guide-modal.vue?vue&type=script&lang=js&"
import style0 from "./guide-modal.vue?vue&type=style&index=0&id=dab04ff2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab04ff2",
  null
  
)

export default component.exports